import Execute from "./Execute";
import List from "./List";
import { ProcedureIcon } from "../icons";

export default {
  options: {
    group: "utility",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("procedure/list") !== -1,
  },
  icon: ProcedureIcon,
  list: List,
  execute: Execute,
};
